import { useEffect, useState } from "react";
import { Card, Checkbox, Modal, Skeleton, Typography } from "antd";
import { Caracteristicas } from "../../../interfaces/Caracteristicas";
import {
  CadastrarCaracteristicasAptoDTO,
  CaracteristicasApto,
} from "../../../interfaces/CaracteristicasApto";
import { useMessage } from "../../../uteis/mensagens/useMessage";
import { useBuscarCaracteristicas } from "../hooks/useBuscarCaracteristicas";
import { useCadastrarCaracteristicasApto } from "../hooks/useCadastrarCaracteristicasApto";

type ModalCaracteristicasProps = {
  isModalOpen: boolean;
  handleFechar: () => void;
  aptoId: number | null;
};

export default function ModalCaracteristicas({
  isModalOpen,
  handleFechar,
  aptoId,
}: ModalCaracteristicasProps) {
  const [selecionados, setSelecionados] = useState<number[]>([]);
  const [caracteristicasAptoOrigin, setCaracteristicasAptoOrigin] = useState<
    CaracteristicasApto[]
  >([]);
  const [caracteristicasApto, setCaracteristicasApto] =
    useState<CadastrarCaracteristicasAptoDTO>({
      aptoId: aptoId || 0,
      caracteristicaId: [],
    });

  const { showSuccess, showError, contextHolder } = useMessage();
  const {
    caracteristicas,
    caracteristicasApto: caracteristicasVinculadas,
    isLoading,
  } = useBuscarCaracteristicas(isModalOpen, aptoId);
  const {
    cadastrar,
    isLoading: isLoadingCadastrar,
    error,
    success,
    resetError,
    resetSuccess,
  } = useCadastrarCaracteristicasApto();

  const [errorDisplayed, setErrorDisplayed] = useState(false);
  const [successDisplayed, setSuccessDisplayed] = useState(false);

  const handleChange = (values: number[]) => {
    setSelecionados(values);
    setCaracteristicasApto({
      aptoId: aptoId || 0,
      caracteristicaId: values,
    });
  };

  useEffect(() => {
    const ids =
      caracteristicasVinculadas?.map((item) => item.caracteristicaId) ?? [];

    setSelecionados(ids);
    setCaracteristicasAptoOrigin(caracteristicasVinculadas ?? []);
    setCaracteristicasApto({
      aptoId: aptoId || 0,
      caracteristicaId: ids,
    });
  }, [aptoId, caracteristicasVinculadas]);

  useEffect(() => {
    if (success && !successDisplayed) {
      showSuccess(success);
      setSuccessDisplayed(true);

      setTimeout(() => {
        setSuccessDisplayed(false);
        resetSuccess();
        handleFechar();
      }, 2000);
    }

    if (error && !errorDisplayed) {
      showError(error);
      setErrorDisplayed(true);

      setTimeout(() => {
        setErrorDisplayed(false);
        resetError();
      }, 3000);
    }
  }, [
    error,
    errorDisplayed,
    handleFechar,
    resetError,
    resetSuccess,
    showError,
    showSuccess,
    success,
    successDisplayed,
  ]);

  return (
    <Modal
      open={isModalOpen}
      onCancel={handleFechar}
      cancelText="Cancelar"
      okText={caracteristicasAptoOrigin.length > 0 ? "Atualizar" : "Salvar"}
      confirmLoading={isLoadingCadastrar}
      onOk={() => cadastrar(caracteristicasApto, caracteristicasAptoOrigin)}
      okButtonProps={{
        style: {
          backgroundColor: "#003644",
          borderColor: "#003644",
          color: "white",
        },
      }}
      cancelButtonProps={{
        style: {
          backgroundColor: "#f44336",
          borderColor: "#f44336",
          color: "white",
        },
      }}
    >
      {contextHolder}
      {isLoading ? (
        <Skeleton active />
      ) : (
        <Card
          title={<Typography.Title level={4}>Caracteristicas</Typography.Title>}
          style={{
            width: "100%",
            marginTop: "20px",
            borderRadius: "10px",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
          }}
        >
          <Checkbox.Group
            options={caracteristicas?.map((item: Caracteristicas) => ({
              label: item.nome,
              value: item.id,
            }))}
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "12px",
              alignItems: "center",
            }}
            onChange={(values) => handleChange(values as number[])}
            value={selecionados}
          />
        </Card>
      )}
    </Modal>
  );
}
